// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c0683b38","80":"632a1e31","89":"cf810e17","105":"e7f8223e","111":"5158d7cb","453":"ae0f3a3b","489":"d9b0f696","575":"889d3459","592":"d6847e30","614":"38215b47","795":"7ad3fffe"}[chunkId] + ".chunk.js";
};